import * as React from "react";
import { ProgressRingControl } from '../../../../../Intercom.ReactUI/Views/ProgressRingControl';

export class DialogStatusProps {
    statusMessage?: string;
}

export class DialogStatusState {
    showing?: boolean;
}

export class DialogStatus extends React.Component<DialogStatusProps, DialogStatusState> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    /** Renders the component */
    public render(): JSX.Element {
        return (
            this.state.showing ?
            <div className={"dialog-status-container"}>
                <ProgressRingControl className={"progress-large"} />
                { this.props.statusMessage && <span className={"dialog-status-message"}>{ this.props.statusMessage }</span> }
            </div> : null
        );
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/status/DialogStatus.tsx